import { Constants } from "@/constants/constants";


const TermsPage = () => {
  return (
      <div className="pt-20">
        <section className="bg-gradient-to-br from-white via-sky-50 to-sky-50 py-20">
          <div className="max-w-3xl mx-auto prose prose-neutral">
            <p className="text-muted-foreground leading-relaxed mb-8">
              Last updated: April 1, 2026
            </p>

            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Agreement to Terms
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  By accessing or using {Constants.SITE_NAME}&apos;s website and services, you agree 
                  to be bound by these Terms of Service. If you do not agree with any part of 
                  these terms, you may not access our website or use our services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Services
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  {Constants.SITE_NAME} provides self-service laundry facilities and may offer additional services 
                  such as wash-and-fold, commercial laundry, or other related services.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Service availability, pricing, hours of operation, and equipment availability may change without notice.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Customer Responsibilities
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Customers are responsible for:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground mb-4">
                  <li>Following all posted instructions and safety notices.</li>
                  <li>Using equipment properly and responsibly.</li>
                  <li>Monitoring personal belongings while on the premises.</li>
                  <li>Ensuring items placed in washers and dryers are suitable for laundering.</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mb-4">
                 Customers are responsible for checking garment care labels before using our equipment.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Lost, Stolen, or Damaged Items
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  {Constants.SITE_NAME} is not responsible for:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground mb-4">
                  <li>Lost or stolen personal property.</li>
                  <li>Items left unattended.</li>
                  <li>Damage resulting from improper use of equipment.</li>
                  <li>Damage caused by unsuitable fabrics, pre-existing garment conditions, or failure to follow care instructions.</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mb-4">
                 Customers use our facilities and equipment at their own risk.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Payment Terms
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  All service fees must be paid at the time services are provided unless otherwise agreed.
                </p>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We reserve the right to:
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                  <li>Refuse service for non-payment.</li>
                  <li>Correct pricing errors.</li>
                  <li>Modify service pricing at any time without prior notice.</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Any refunds are provided at our sole discretion and in accordance with applicable laws.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Website Content
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  All content on this website, including text, graphics, logos, images, and other materials, 
                  is the property of {Constants.SITE_NAME} or its licensors and is protected by applicable intellectual property laws.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  You may not copy, reproduce, distribute, or modify website content without prior written permission.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Third-Party Links
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  Our website may contain links to third-party websites for your convenience.
                </p>
                 <p className="text-muted-foreground leading-relaxed mb-4">
                  We do not control or endorse third-party websites and are not responsible for their content, policies, or practices.
                </p>
                 <p className="text-muted-foreground leading-relaxed mb-4">
                 Your use of third-party websites is at your own risk.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Disclaimer of Warranties
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  The website and services are provided on an "as is" and "as available" basis
                </p>
                 <p className="text-muted-foreground leading-relaxed mb-4">
                 To the fullest extent permitted by law, {Constants.SITE_NAME} disclaims all warranties, express or implied, 
                 including warranties of merchantability, fitness for a particular purpose, and non-infringement.
                </p>
                 <p className="text-muted-foreground leading-relaxed mb-4">
                 We do not guarantee uninterrupted, error-free, or secure access to the website or services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Limitation of Liability
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  To the fullest extent permitted by law, {Constants.SITE_NAME}, its owners, employees,
                   and affiliates shall not be liable for any indirect, incidental, consequential, special, or punitive damages arising from:                  
                </p>
                <ul className="list-disc list-inside space-y-2 text-muted-foreground mb-4">
                  <li>Use of or inability to use our website;</li>
                  <li>Use of our facilities or equipment;</li>
                  <li>Loss, theft, or damage to personal property;</li>
                  <li>Service interruptions or equipment failures.</li>
                </ul>
                <p className="text-muted-foreground leading-relaxed">
                  Our total liability for any claim shall not exceed the amount paid by the customer for the applicable service.                  
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Indemnification
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  You agree to indemnify and hold harmless {Constants.SITE_NAME}, its owners, employees, 
                  and affiliates from any claims, damages, liabilities, costs, or expenses arising from 
                  your violation of these Terms or misuse of our website or services.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Privacy
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                 Your use of our website is also governed by our Privacy Policy, which explains how we collect,
                  use, and protect personal information.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Changes to Terms
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  We may update these Terms at any time without prior notice.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  Changes become effective when posted on this website. Continued use of the website or
                   services after changes are posted constitutes acceptance of the revised Terms.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Governing Law
                </h2>
                <p className="text-muted-foreground leading-relaxed mb-4">
                  These Terms shall be governed by and interpreted in accordance with the laws of 
                  the Province of Ontario and the applicable laws of Canada.
                </p>
                <p className="text-muted-foreground leading-relaxed">
                  Any disputes arising from these Terms shall be subject to the exclusive 
                  jurisdiction of the courts located in Ontario.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Changes to Terms
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  We reserve the right to modify these Terms of Service at any time. Changes 
                  will be effective immediately upon posting to our website. Your continued 
                  use of our services constitutes acceptance of any modified terms.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-medium mb-4">
                  Contact Us
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  If you have any questions about these Terms of Service, please contact us at{" "}
                  <a
                    href={`mailto:${Constants.SITE_EMAIL}`}
                    className="text-primary hover:underline"
                  >
                    {Constants.SITE_EMAIL}
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default TermsPage;